module.exports = __webpack_public_path__ + "static/cristian-palmer-XexawgzYOBc-unsplash-a50326deaa4daf7df939b28145544f5d.jpg";